import type { CSSProperties, FunctionalComponent as FC } from 'vue'
import type { ShareParams, UserInfo } from '~/api/interface'
import EmptyView from '~/components/emptyView/index.vue'
import { share } from '~/api'
import Resource from '~/components/resource'

const handShare = async (
  data: UserInfo,
  event: TRACK_EVENT,
  params: ShareParams,
  trackParams?: any
) => {
  const { $t } = useNuxtApp()
  if (trackParams) {
    trackEvent(event, {
      ...trackParams,
      share_mode: 1,
      share_with: data.user_id,
    })
  }
  const { code } = await share({
    ...params,
    target_user_id: data.user_id,
  })
  if (code !== 0) {
    return
  }
  message.success($t('fen-xiang-cheng-gong'))
}

export const ShareMembers: FC<{
  list: UserInfo[]
  loading?: boolean
  eventName: TRACK_EVENT
  params: ShareParams
  trackParams?: any
  style?: CSSProperties
}> = (props) => {
  const { $t } = useNuxtApp()
  return (
    <ul
      class="relative flex flex-col gap-[4px] my-[12px] overflow-y-auto pr-[10px] -mr-[20px] select-none"
      style={props.style}
    >
      {props?.list?.map((item) => (
        <li class="h-[24px] flex-y-center p-[4px_10px] rounded-[6px] hover:bg-back-3">
          <Resource
            src={item?.logo_url}
            transformResource={transformImage}
            class="w-[24px] h-[24px] rounded-[50%] mr-[12px]"
          />
          <span class="text-14 flex-1">{item?.account_name}</span>
          <a-button
            type="link"
            class="hover:font-semibold button-animote-circle p-0 h-auto"
            onClick={() =>
              handShare(item, props.eventName, props.params, props?.trackParams)
            }
          >
            {$t('fen-xiang')}
          </a-button>
        </li>
      ))}
      {!props?.list?.length && (
        <li class="w-full h-full flex-center">
          <EmptyView style="min-height: 170px" height="100px">
            {{
              content: () =>
                $t('mei-you-pi-pei-jie-guo-huan-ge-guan-jian-ci-shi-shi-ba'),
            }}
          </EmptyView>
        </li>
      )}
      {props?.loading && (
        <li class="w-full h-full flex-center absolute top-0 left-0 bg-back-1 bg-opacity-60">
          <a-spin></a-spin>
        </li>
      )}
    </ul>
  )
}
